const BarChartIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg viewBox="0 0 800 600" {...props}>
      <g transform="translate(100, 50)">
        <g className="ez-grid">
          <line
            transform="translate(0, 431.5)"
            x2="600"
            y2="0"
            className="ez-grid-line"
          ></line>
          <line
            transform="translate(0, 310.5)"
            x2="600"
            y2="0"
            className="ez-grid-line"
          ></line>
          <line
            transform="translate(0, 189.5)"
            x2="600"
            y2="0"
            className="ez-grid-line"
          ></line>
          <line
            transform="translate(0, 68.5)"
            x2="600"
            y2="0"
            className="ez-grid-line"
          ></line>
        </g>
        <g className="ez-grid">
          <line
            transform="translate(0.5, 0)"
            x2="0"
            y2="500"
            className="ez-grid-line"
          ></line>
          <line
            transform="translate(50.5, 0)"
            x2="0"
            y2="500"
            className="ez-grid-line"
          ></line>
          <line
            transform="translate(100.5, 0)"
            x2="0"
            y2="500"
            className="ez-grid-line"
          ></line>
          <line
            transform="translate(150.5, 0)"
            x2="0"
            y2="500"
            className="ez-grid-line"
          ></line>
          <line
            transform="translate(200.5, 0)"
            x2="0"
            y2="500"
            className="ez-grid-line"
          ></line>
          <line
            transform="translate(250.5, 0)"
            x2="0"
            y2="500"
            className="ez-grid-line"
          ></line>
          <line
            transform="translate(300.5, 0)"
            x2="0"
            y2="500"
            className="ez-grid-line"
          ></line>
          <line
            transform="translate(350.5, 0)"
            x2="0"
            y2="500"
            className="ez-grid-line"
          ></line>
          <line
            transform="translate(400.5, 0)"
            x2="0"
            y2="500"
            className="ez-grid-line"
          ></line>
          <line
            transform="translate(450.5, 0)"
            x2="0"
            y2="500"
            className="ez-grid-line"
          ></line>
          <line
            transform="translate(500.5, 0)"
            x2="0"
            y2="500"
            className="ez-grid-line"
          ></line>
          <line
            transform="translate(550.5, 0)"
            x2="0"
            y2="500"
            className="ez-grid-line"
          ></line>
          <line
            transform="translate(600.5, 0)"
            x2="0"
            y2="500"
            className="ez-grid-line"
          ></line>
        </g>
        <g className="ez-bars">
          <rect
            fill="#26547c"
            x="0"
            y="377"
            width="90"
            height="109"
            data-testid="ez-bar"
            className="ez-bar"
          ></rect>
          <rect
            fill="#ef476f"
            x="0"
            y="256"
            width="450"
            height="109"
            data-testid="ez-bar"
            className="ez-bar"
          ></rect>
          <rect
            fill="#ffd166"
            x="0"
            y="135"
            width="290"
            height="109"
            data-testid="ez-bar"
            className="ez-bar"
          ></rect>
          <rect
            fill="#06d6a0"
            x="0"
            y="14"
            width="300"
            height="109"
            data-testid="ez-bar"
            className="ez-bar"
          ></rect>
        </g>
        <g
          textAnchor="middle"
          transform="translate(0, 500)"
          className="ez-axis"
        >
          <path d="M0.5,6V-6V-0.5H600.5V6V-6" className="ez-axis-path"></path>
          <g transform="translate(0.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text y="9" dy="0.71em" className="ez-axis-tick-text">
              0
            </text>
          </g>
          <g transform="translate(50.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text y="9" dy="0.71em" className="ez-axis-tick-text">
              5
            </text>
          </g>
          <g transform="translate(100.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text y="9" dy="0.71em" className="ez-axis-tick-text">
              10
            </text>
          </g>
          <g transform="translate(150.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text y="9" dy="0.71em" className="ez-axis-tick-text">
              15
            </text>
          </g>
          <g transform="translate(200.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text y="9" dy="0.71em" className="ez-axis-tick-text">
              20
            </text>
          </g>
          <g transform="translate(250.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text y="9" dy="0.71em" className="ez-axis-tick-text">
              25
            </text>
          </g>
          <g transform="translate(300.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text y="9" dy="0.71em" className="ez-axis-tick-text">
              30
            </text>
          </g>
          <g transform="translate(350.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text y="9" dy="0.71em" className="ez-axis-tick-text">
              35
            </text>
          </g>
          <g transform="translate(400.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text y="9" dy="0.71em" className="ez-axis-tick-text">
              40
            </text>
          </g>
          <g transform="translate(450.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text y="9" dy="0.71em" className="ez-axis-tick-text">
              45
            </text>
          </g>
          <g transform="translate(500.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text y="9" dy="0.71em" className="ez-axis-tick-text">
              50
            </text>
          </g>
          <g transform="translate(550.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text y="9" dy="0.71em" className="ez-axis-tick-text">
              55
            </text>
          </g>
          <g transform="translate(600.5, 0)" className="ez-axis-tick">
            <line x2="0" y2="6" className="ez-axis-tick-line"></line>
            <text y="9" dy="0.71em" className="ez-axis-tick-text">
              60
            </text>
          </g>
        </g>
        <g textAnchor="end" transform="translate(0, 0)" className="ez-axis">
          <path d="M6,500.5H-6H-0.5V0.5H6,-6" className="ez-axis-path"></path>
          <g transform="translate(0, 431.5)" className="ez-axis-tick">
            <line x2="-6" y2="0" className="ez-axis-tick-line"></line>
            <text x="-9" dy="0.32em" className="ez-axis-tick-text">
              Alpha
            </text>
          </g>
          <g transform="translate(0, 310.5)" className="ez-axis-tick">
            <line x2="-6" y2="0" className="ez-axis-tick-line"></line>
            <text x="-9" dy="0.32em" className="ez-axis-tick-text">
              Beta
            </text>
          </g>
          <g transform="translate(0, 189.5)" className="ez-axis-tick">
            <line x2="-6" y2="0" className="ez-axis-tick-line"></line>
            <text x="-9" dy="0.32em" className="ez-axis-tick-text">
              Gamma
            </text>
          </g>
          <g transform="translate(0, 68.5)" className="ez-axis-tick">
            <line x2="-6" y2="0" className="ez-axis-tick-line"></line>
            <text x="-9" dy="0.32em" className="ez-axis-tick-text">
              Delta
            </text>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default BarChartIcon;
